/*
 * Copyright (c) 2026. Orion Analytics. All Rights Reserved
 */

import React, { useState } from 'react';

// const tabs = [
//   'Large Cap',
//   'Mid Cap',
//   'Small Cap',
//   'Flexi Cap',
//   'Debt',
//   'Hybrid'
// ];

const tabs = [
"Other",
"Hybrid",
"Equity",
"Debt"
];

const TopFundsTable = ({ data }) => {

  const [selectedTab, setSelectedTab] = useState('Equity');
  console.log('DATA ->', data)

  const filtered = data.filter(
    // item => item.sub_category === selectedTab
    item => item.category === selectedTab
  );
    // console.log('SELECTED TAB = ',selectedTab)
    // console.log('FILTERED DATA ->', filtered)
  return (

    <div className="bg-white rounded-3xl p-8 shadow-sm border">

      <div className="flex justify-between items-center mb-8">

        <div>
          <h2 className="text-3xl font-bold">
            Expert Picks
          </h2>

          <p className="text-gray-500 mt-2">
            Top performing funds by category
          </p>
        </div>


        <div className="flex gap-3">

          {tabs.map(tab => (

            <button
              key={tab}
              onClick={() => setSelectedTab(tab)}
              className={`px-5 py-2 rounded-xl text-sm font-medium
              ${selectedTab === tab
                ? 'bg-green-700 text-white'
                : 'bg-gray-100'}
              `}
            >
              {tab}
            </button>

          ))}

        </div>

      </div>


      <div className="overflow-auto">

        <table className="w-full">

          <thead>
            <tr className="text-left border-b">
              <th className="py-6">Fund</th>
              <th>1Y Return</th>
              <th>3Y Return</th>
              <th>5Y Return</th>
              <th>Risk</th>
              <th></th>
            </tr>
          </thead>


          <tbody>

            {filtered.slice(0, 10).map((fund, index) => (

              <tr key={index} className="border-b">

                <td className="py-5">
                  <div className="font-semibold">
                    {fund.scheme_name}
                  </div>

                  <div className="text-sm text-gray-500">
                    {fund.sub_category}
                  </div>
                </td>

                <td className="font-bold text-green-700">
                  {fund.return_1y?.toFixed(2)}%
                </td>


                <td className="font-bold text-green-700">
                  {fund.return_3y?.toFixed(2)}%
                </td>


                <td>
                  {fund.return_5y?.toFixed(2)}%
                </td>


                <td>
                  {fund.risk_grade}
                </td>
                <td>

                </td>

                <td>
                  <button className="bg-green-700 text-white px-5 py-2 rounded-full">
                    Invest
                  </button>
                </td>

              </tr>

            ))}

          </tbody>

        </table>

      </div>

    </div>
  );
};

export default TopFundsTable;